import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'

const baseUrl = (cityId) => urljoin(ServicesUtils.apiUrl, 'city', cityId.toString(), 'store-notifications')

async function sendNotification (notification, storeId, cityId, token)
{
    const url = urljoin(baseUrl(cityId), storeId.toString(), 'send')
    const response = await axios.post(url, notification, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}
    
async function fetchStoreNotifications (cityId)
{
    const url = baseUrl(cityId)
    const response = await axios.get(url)

    return response.data
}

async function fetchNotificationQuota (storeId, cityId, token)
{
    const url = urljoin(baseUrl(cityId), storeId.toString(), 'quota')
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

export default { sendNotification, fetchStoreNotifications, fetchNotificationQuota }


// WEBPACK FOOTER //
// ./src/services/storeNotifications.js